import { render, staticRenderFns } from "./hairfilesdetailNew.vue?vue&type=template&id=35cf5a72&scoped=true&"
import script from "./hairfilesdetailNew.vue?vue&type=script&lang=js&"
export * from "./hairfilesdetailNew.vue?vue&type=script&lang=js&"
import style0 from "./hairfilesdetailNew.vue?vue&type=style&index=0&id=35cf5a72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf5a72",
  null
  
)

export default component.exports